import styled from "styled-components";

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 28px 32px 24px;
  max-width: 460px;
`;

export const NewPill = styled.span`
  align-self: flex-start;
  background: ${({ theme }) => theme.subscribe};
  color: #fff;
  font-family: ${({ theme }) => theme.p3b.ff};
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 12px;
`;

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.h2.ff};
  font-size: 22px;
  line-height: 1.25;
  margin: 0;
  color: #fff;
`;

export const Lede = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.5;
`;

export const LedeStrong = styled.p`
  margin: 0;
  color: #fff;
  line-height: 1.5;
  font-family: ${({ theme }) => theme.fontHeavy};
`;

export const Bullets = styled.ul`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: rgba(255, 255, 255, 0.88);
  li {
    line-height: 1.45;
  }
  li::marker {
    color: ${({ theme }) => theme.subscribe};
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 6px;
`;

export const StudioFigure = styled.figure`
  position: relative;
  margin: 8px 0 0;
  border-radius: 6px;
  overflow: hidden;
  line-height: 0;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    box-shadow: inset 0 0 50px 14px rgba(0, 0, 0, 0.45);
    pointer-events: none;
  }
`;

export const StudioImg = styled.img`
  width: 100%;
  height: 140px;
  display: block;
  object-fit: cover;
  object-position: center;
  filter: grayscale(1);
  opacity: 0.8;
`;

export const StudioCaption = styled.figcaption`
  position: absolute;
  bottom: 10px;
  right: 14px;
  font-family: ${({ theme }) => theme.p3r.ff};
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 0.02em;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
  z-index: 1;
`;
